import React, { useEffect, useMemo } from 'react';
import c from 'classnames';
import { useCurrentRefinements, useInstantSearch } from 'react-instantsearch';

import { getSearchFiltersParameter } from '@uncinc/react-searchkit';
import type { SearchParameters } from '@uncinc/react-searchkit/types';

import type { SearchTopicalContentType } from '../types';

interface ChildProps {
  contentType: SearchTopicalContentType | undefined;
}

export interface SearchTopicalResultsProps {
  className?: string;
  children: (childProps: ChildProps) => React.ReactNode;
  setSearchParameters: (searchParameters: SearchParameters) => void;
}

const SearchTopicalResults: React.FC<SearchTopicalResultsProps> = (props) => {
  const {
    className,
    children,
    setSearchParameters,
  } = props;

  const classNames = c('SearchTopical__Results', className);

  const { indexUiState } = useInstantSearch();
  const { items } = useCurrentRefinements();

  const contentType = useMemo(() => (
    items.find((item) => item.attribute === 'type')?.refinements[0]?.value
  ), [items]) as SearchTopicalContentType | undefined;

  // Set the initial search parameters on mount.
  useEffect(() => {
    setSearchParameters({
      filters: getSearchFiltersParameter(indexUiState),
      page: 0,
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classNames}>
      {children({ contentType })}
    </div>
  );
};

export default SearchTopicalResults;
